import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-unita-locali-dati-generali',
  templateUrl: './view-unita-locali-dati-generali.component.html',
  styleUrls: ['./view-unita-locali-dati-generali.component.css']
})
export class ViewUnitaLocaliDatiGeneraliComponent implements OnInit {
  @Input() itemData:any;
  
  constructor() { }

  ngOnInit() {
    this.itemData.isProduttore=true;

    /*
    $('.mesi-attivita').on('keyup keydown change', function(e){
   
      if (($(this).val() as number) > 12 
          && e.keyCode !== 46
          && e.keyCode !== 8
         ) {
         e.preventDefault();     
         $(this).val(12);
      }
    });
    */
  }

}
